import { render, staticRenderFns } from "./color.vue?vue&type=template&id=626b3cae&scoped=true&"
import script from "./color.vue?vue&type=script&lang=js&"
export * from "./color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626b3cae",
  null
  
)

export default component.exports